import Link from 'next/link'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const ForPartnersAgree = ({ register, setValue, text } : {register: any, setValue: any, text?: any}) => {
    const { t } = useTranslation()
    const [isChecked, setIsChecked] = useState(false)

    const onChangeState = () => {
        const currentState = isChecked
        setIsChecked(!isChecked)
        // setValue(currentState)
    }

    return (
        <div className={`for-partners__input-block for-partners__agree ${isChecked && 'for-partners__agree_checked'}`}>
            <p className='for-partners__label-text'>
                {text ? (
                    text
                ) : (
                    <>
                        {t('agree1')}
                        
                        <Link
                            className={`for-partners__politics`}
                         href={"/user-confidential"}>{t('agree3')}</Link>
                        {t('agree4')}
                        <Link
                            href={'/confidential'}
                            className={`for-partners__politics`}
                        >
                            {t('agree2')}
                        </Link>
                    </>
                )}
            </p>
            <label className='for-partners__checkbox'>
                <div>
                    <input
                        onChangeCapture={onChangeState}
                        type='checkbox'
                        name='robot'
                        {...register('robot', { required: true })}
                    />
                    <span className='for-partners__checkbox-icon'>
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 13 10'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M2 4.25L5.75 8L11 2'
                                stroke='#EAF0FF'
                                strokeWidth='2'
                                strokeLinecap='square'
                            />
                        </svg>
                    </span>
                    <span className='for-partners__agree-text'>{t('agree')}</span>
                </div>
            </label>
        </div>
    )
}

export default ForPartnersAgree
